import React, { useState, useEffect } from 'react';
import { Clock, Percent, Gift, Zap } from 'lucide-react';

const deals = [
  {
    id: 1,
    title: 'Weekend Special',
    description: 'Extra 20% off on all vitamins',
    code: 'WEEKEND20',
    icon: Gift,
    bgGradient: 'from-violet-500 to-purple-600',
    validUntil: 'Sun midnight',
  },
  {
    id: 2,
    title: 'First Order',
    description: 'Get $10 off on orders above $50',
    code: 'FIRST10',
    icon: Zap,
    bgGradient: 'from-amber-500 to-orange-600',
    validUntil: 'Limited time',
  },
  {
    id: 3,
    title: 'Bundle Deal',
    description: 'Buy 2 Get 1 Free on skincare',
    code: 'BUNDLE3',
    icon: Percent,
    bgGradient: 'from-rose-500 to-pink-600',
    validUntil: '48 hours left',
  },
];

const PromotionalBanner = () => {
  const [currentDeal, setCurrentDeal] = useState(0);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDeal((prev) => (prev + 1) % deals.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const deal = deals[currentDeal];
  const Icon = deal.icon;

  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className={`relative overflow-hidden rounded-3xl bg-gradient-to-r ${deal.bgGradient} p-8 md:p-10`}>
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full blur-2xl transform -translate-x-1/2 translate-y-1/2" />
          
          {/* Floating shapes */}
          <div className="absolute top-10 right-20 w-4 h-4 bg-white/30 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }} />
          <div className="absolute bottom-10 right-40 w-3 h-3 bg-white/20 rounded-full animate-bounce" style={{ animationDelay: '1s' }} />
          <div className="absolute top-20 right-60 w-2 h-2 bg-white/40 rounded-full animate-bounce" style={{ animationDelay: '1.5s' }} />

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Left Content */}
            <div className="flex items-center gap-6">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                <Icon className="w-10 h-10 text-white" />
              </div>
              <div className="text-white">
                <div className="flex items-center gap-2 mb-1">
                  <Clock className="w-4 h-4 text-white/80" />
                  <span className="text-sm text-white/80">{deal.validUntil}</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-1">{deal.title}</h3>
                <p className="text-white/90">{deal.description}</p>
              </div>
            </div>

            {/* Right - Coupon Code */}
            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center gap-2">
                <div className="px-6 py-3 bg-white/20 backdrop-blur-sm rounded-xl border-2 border-dashed border-white/50">
                  <span className="text-xl font-mono font-bold text-white tracking-wider">
                    {deal.code}
                  </span>
                </div>
                <button
                  onClick={() => handleCopyCode(deal.code)}
                  className="px-4 py-3 bg-white text-gray-800 font-semibold rounded-xl hover:bg-gray-100 transition-colors"
                >
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
              
              {/* Deal Indicators */}
              <div className="flex gap-2">
                {deals.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentDeal(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === currentDeal ? 'w-6 bg-white' : 'bg-white/40'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;
